import { render, staticRenderFns } from "./TicimaxKategori.vue?vue&type=template&id=f1f5c37e&scoped=true&"
import script from "./TicimaxKategori.vue?vue&type=script&lang=js&"
export * from "./TicimaxKategori.vue?vue&type=script&lang=js&"
import style0 from "./TicimaxKategori.vue?vue&type=style&index=0&id=f1f5c37e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f5c37e",
  null
  
)

export default component.exports